<template lang="pug">
	div.container-fluid
		.card
			.card-header.bg-info.text-white
				span.fa.fa-search.mr-2
				| Búsqueda de eventos
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Texto
							input.form-control(placeholder="Busca por texto", v-model="filtro.cadena", @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Fecha inicio
							.input-group
								datepicker(
									:monday-first="true"
									:bootstrap-styling="true"
									input-class="form-control"
									placeholder="Selecciona"
									v-model="filtro.FechaInicio"
									@input="buscar"
								)
								.input-group-append
									button.btn.btn-danger(v-if="filtro.FechaInicio" @click="quitarFechaInicio")
										span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Fecha fin
							.input-group
								datepicker(
									:monday-first="true"
									:bootstrap-styling="true"
									input-class="form-control"
									placeholder="Selecciona"
									v-model="filtro.FechaFin"
									@input="buscar"
								)
								.input-group-append
									button.btn.btn-danger(v-if="filtro.FechaFin" @click="quitarFechaFin")
										span.fa.fa-trash
			.card-footer
				button.btn.btn-primary.mr-2(@click="buscar")
					span.fa.fa-search.mr-2
					| Buscar
				button.btn.btn-danger(@click="nuevo")
					span.fa.fa-plus.mr-2
					| Nuevo evento


		.card.mt-3
			.card-header.bg-dark.text-white
				span.fa.fa-list.mr-2
				| Resultados
			table.table.table-striped.m-0
				thead
					tr
						th ID
						th Título
						th Inicio
						th Fin
						th Activo
						th Asistentes
						th Opciones
				tbody

					tr(
						v-for="evento in resultadosFiltrados"
						:key="evento.EventoID"
					)
						td {{evento.EventoID}}
						td {{evento.Titulo}}
						td {{evento.FechaInicioEvento | moment('DD-MM-YYYY')}} a las {{evento.FechaInicioEvento | moment('H:mm')}}
						td {{evento.FechaFinEvento | moment('DD-MM-YYYY')}} a las {{evento.FechaFinEvento | moment('H:mm')}}
						td.text-white(:class="(evento.Activo) ? 'bg-success' : 'bg-danger'")
							span(v-if="evento.Activo") Activo
							span(v-else) Inactivo
						td {{evento.Asistentes}} asistentes
						td
							button.m-1.btn.btn-sm.btn-dark(@click="$router.push('/main/eventos/ver/' + evento.EventoID)")
								span.fa.fa-home.mr-2
								| Acceder

							button.m-1.btn.btn-sm.btn-warning(@click="editar(evento)")
								span.fa.fa-edit.mr-2
								| Editar

							button.m-1.btn.btn-sm.btn-primary(@click="promocionar(evento)")
								span.fa.fa-envelope.mr-2
								| Promocionar

							button.m-1.btn.btn-sm.btn-danger(@click="eliminar(evento.EventoID)")
								span.fa.fa-trash.mr-2
								| Eliminar

							a.m-1.btn.btn-sm.btn-success(:href="'https://eventos.radiocastellon.com/#/' + evento.PublicID", target="_blank")
								span.fa.fa-external-link

</template>

<style>
.form-group .vdp-datepicker .input-group > input {
  background-color: white !important;
}
</style>

<script>
export default {
	data () {
		return {
			filtro: {
				cadena: '',
				FechaInicio: null,
				FechaFin: null
			},
			resultados: []
		}
	},
	created () {
		this.buscar()
	},
	computed: {
		resultadosFiltrados () {
			return this.resultados.map(r => {
				const asis = typeof r.Asistentes === 'number' ? r.Asistentes : 0
				const inscritos = typeof r.AsistentesInscritos === 'number' ? r.AsistentesInscritos : 0
				r.Asistentes = asis + inscritos
				return r
			})
		}
	},
	methods: {
		buscar () {
			const form = JSON.parse(JSON.stringify(this.filtro))
			form.FechaInicio = (this.filtro.FechaInicio) ? Math.floor(this.filtro.FechaInicio.getTime() / 1000) : null
			form.FechaFin = (this.filtro.FechaFin) ? Math.floor(this.filtro.FechaFin.getTime() / 1000) : null

			this.$http.post('/eventos/php/api/buscarEventos.php', form)
				.then(res => {
					this.resultados = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		nuevo () {
			this.$router.push('/main/eventos/editor')
		},
		editar (evento) {
			this.$router.push('/main/eventos/editor/' + evento.EventoID)
		},
		promocionar (evento) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: 'Opción no implementada por el momento'
			})
		},
		eliminar (EventoID) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar evento',
				mensaje: '¿Quieres eliminar este evento?',
				callback: acepta => {
					if (acepta) {
						this.$http.post('eventos/php/api/delEvento.php', {EventoID: EventoID})
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Evento eliminado'
								})
								this.buscar()
							})
							.catch(e => {
								this.$responseError(e)
							})
					}
				}
			})
		},
		quitarFechaInicio () {
			this.filtro.FechaInicio = null
			this.buscar()
		},
		quitarFechaFin () {
			this.filtro.FechaFin = null
			this.buscar()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/eventos/vue/components/listado/listado.vue